import { Alert, Button, Stack, Text } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { FormattedMessage } from "react-intl";
import { formatPoaDate } from "../../../hooks/api/useGetPoaStatus";

interface InactivePoaBannerProps {
  /** When the newest company answer landed, the "Informationen nedan är från" date. */
  dataFrom: string | null;
  onRenew: () => void;
}

const alertVars = {
  "--alert-bg": "var(--wallet-color-masterbrand-accent-yellow)",
  "--alert-color": "var(--wallet-color-neutrals-black)",
};

const alertStyles = {
  title: { fontSize: "var(--mantine-font-size-lg)" },
  message: { fontSize: "var(--mantine-font-size-sm)" },
} as const;

// Every way a POA stops being valid shares the generic wording, which names no reason.
export function InactivePoaBanner({
  dataFrom,
  onRenew,
}: InactivePoaBannerProps) {
  return (
    <Alert
      role="status"
      c="var(--wallet-color-neutrals-black)"
      __vars={alertVars}
      styles={alertStyles}
      icon={<IconAlertCircle size={20} aria-hidden="true" />}
      title={
        <FormattedMessage
          id="app.poaOverview.inactivation.headline"
          defaultMessage="Din fullmakt är inte aktiv"
        />
      }
    >
      <Stack gap="md">
        <Text size="sm" lh="sm">
          <FormattedMessage
            id="app.poaOverview.inactivation.description"
            defaultMessage="Din informationsfullmakt är inte längre aktiv, så vi kan inte uppdatera din pensionsinformation. Det kan bero på att den har gått ut, att du har återkallat den eller att du inte varit aktiv hos oss på ett tag."
          />
          {dataFrom && (
            <>
              {" "}
              <FormattedMessage
                id="app.poaOverview.inactivation.lastUpdated"
                defaultMessage="Informationen nedan är från {date}."
                values={{ date: formatPoaDate(dataFrom) }}
              />
            </>
          )}
        </Text>
        <Button variant="white" c="black" size="md" fullWidth onClick={onRenew}>
          <FormattedMessage
            id="app.poaOnb.reActivation.CTA"
            defaultMessage="Ge ny fullmakt"
          />
        </Button>
      </Stack>
    </Alert>
  );
}
